export default {

    async reset({ commit }) {
        commit('reset')
    },

    async set({ state, commit }, payload) {
        if (Object.keys(state).includes(payload)) {
            commit('set', payload)
            if (state['show'] === false) {
                commit('reset')
            }
        }
    }
}
